import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Navbar.module.css';
import LanguageSwitcher from './LanguageSwitcher';

// The patient portal is served by this same site at /login (see portal/README.md).
const PORTAL_URL = process.env.REACT_APP_PORTAL_URL || '';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.logo}>
        <img src="/logo.svg" alt="Logo" style={{ width: '45px', height: '45px', marginRight: '12px' }} />
        <div className={styles.logoText}>
          <span className={styles.logoMain}>Children's Health Center</span>
          <span className={styles.logoSub}>Prof. Nune Baghdasaryan · Yerevan</span>
        </div>
      </div>

      <button className={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
        <span className={menuOpen ? styles.barOpen : styles.bar}></span>
        <span className={menuOpen ? styles.barOpen : styles.bar}></span>
        <span className={menuOpen ? styles.barOpen : styles.bar}></span>
      </button>

      <ul className={`${styles.links} ${menuOpen ? styles.open : ''}`}>
        {[
          [t('nav.home'), 'hero'],
          [t('nav.services'), 'services'],
          [t('nav.about'), 'about'],
          [t('nav.contact'), 'contact'],
        ].map(([label, id]) => (
          <li key={id}>
            <button className={styles.link} onClick={() => scrollTo(id)}>{label}</button>
          </li>
        ))}
        <li>
          <a className={styles.portal} href={`${PORTAL_URL}/login?lang=${i18n.language}`}>{t('nav.patientLogin')}</a>
        </li>
        <li>
          <button className={styles.cta} onClick={() => scrollTo('contact')}>{t('nav.bookAppointment')}</button>
        </li>
        <li className={styles.languageItem}>
          <LanguageSwitcher />
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
